export default "__VITE_ASSET__BEoJZPjH__"